<dc-page-header-wave
  [title]="'FAQs'"
  [subtitle]="
    'Here are the answers to some of the most common questions we hear from our appreciated customers.'
  "
>
</dc-page-header-wave>

<dc-faqs-questions></dc-faqs-questions>
<dc-faqs-other-channels></dc-faqs-other-channels>

<dc-cta1 [edge]="'top-left'" [background]="'contrast'"></dc-cta1>

<dc-footer1></dc-footer1>
